document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.do-mobile');
  if (menu) {
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => menu.removeAttribute('open')));
  }

  const models = [...document.querySelectorAll('.do-viewer-model')];
  const controls = [...document.querySelectorAll('.do-viewer-item')];
  controls.forEach((control) => {
    control.addEventListener('click', () => {
      const target = control.dataset.viewerTarget;
      models.forEach((model) => model.classList.toggle('is-active', model.id === target));
      controls.forEach((item) => {
        const active = item === control;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  });

  const message = document.querySelector('[data-contact-prefill="true"]');
  if (message) {
    const service = new URLSearchParams(window.location.search).get('service');
    const select = document.querySelector('#ContactForm-service');
    const templates = {
      '3d-visitenkarten': `Ich interessiere mich für 3D-Visitenkarten.

Einsatz:
Gewünschtes Motiv:
Ungefähre Stückzahl:
Gewünschter Termin:
Foto, Plan oder Download-Link:
Ich sende Unterlagen per E-Mail: ja / nein
Weitere Hinweise:`,
      'individuelle-modelle': `Ich interessiere mich für eine Wire-Art-Skulptur nach Maß.

Einsatz oder Anlass:
Motiv und wichtige Merkmale:
Ungefähre Stückzahl:
Gewünschter Termin:
Vorhandene Unterlagen oder Links:
Weitere Hinweise:`
    };
    if (templates[service]) {
      message.value = templates[service];
      if (select) select.value = service === '3d-visitenkarten' ? '3D-Visitenkarten' : 'Wire-Art nach Maß';
    }
  }

  const emailInquiry = document.querySelector('[data-email-inquiry]');
  if (emailInquiry) {
    const form = emailInquiry.closest('.do-form');
    const serviceField = form?.querySelector('#ContactForm-service');
    const messageField = form?.querySelector('#ContactForm-body');
    const nameField = form?.querySelector('#ContactForm-name');
    const companyField = form?.querySelector('#ContactForm-company');
    const phoneField = form?.querySelector('#ContactForm-phone');

    const updateEmailInquiry = () => {
      const emailAddress = emailInquiry.dataset.emailAddress;
      const selectedService = serviceField?.value || 'einem 3DOffice-Projekt';
      const description = messageField?.value.trim();
      const sender = [nameField?.value.trim(), companyField?.value.trim()].filter(Boolean).join(', ');
      const lines = [
        'Guten Tag,',
        '',
        `ich möchte weitere Informationen zu ${selectedService}.`,
      ];

      if (description) lines.push('', description);
      lines.push(
        '',
        'Bitte informieren Sie mich über die Machbarkeit, die nächsten Schritte und den voraussichtlichen Ablauf.',
        '',
        'Freundliche Grüße'
      );
      if (sender) lines.push(sender);
      if (phoneField?.value.trim()) lines.push(`Telefon: ${phoneField.value.trim()}`);

      emailInquiry.href = `mailto:${emailAddress}?subject=${encodeURIComponent(`Anfrage: ${selectedService}`)}&body=${encodeURIComponent(lines.join('\n'))}`;
    };

    form?.querySelectorAll('input, select, textarea').forEach((field) => {
      field.addEventListener('input', updateEmailInquiry);
      field.addEventListener('change', updateEmailInquiry);
    });
    updateEmailInquiry();
  }
});

